/* RIVERA EYEWEAR — interacciones de las secciones rv-* (sin librerías) */
(function () {
  'use strict';
  var docEl = document.documentElement;
  docEl.classList.add('rv-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Partir títulos en líneas animables ---------- */
  function initSplit(ctx) {
    $all('[data-rv-split]:not([data-rv-hecho])', ctx).forEach(function (el) {
      el.setAttribute('data-rv-hecho', '');
      var lineas = el.innerHTML.split(/<br\s*\/?>/i);
      el.innerHTML = lineas.map(function (l, i) {
        return '<span class="rv-linea-mask"><span style="--rv-i:' + i + '">' + l + '</span></span>';
      }).join('');
    });
  }

  /* ---------- Un único observador para todas las entradas ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }) : null;

  function initReveal(ctx) {
    $all('[data-rv-stagger]', ctx).forEach(function (grupo) {
      var paso = parseFloat(grupo.getAttribute('data-rv-stagger')) || 0.1;
      $all('[data-rv-reveal], .rv-media-reveal', grupo).forEach(function (el, i) {
        if (!el.style.getPropertyValue('--rv-d')) el.style.setProperty('--rv-d', (i * paso).toFixed(2) + 's');
      });
    });
    $all('[data-rv-reveal], [data-rv-split], .rv-media-reveal, .rv-pasos', ctx).forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---------- Parallax suave (solo transform) ---------- */
  var parallax = [];
  function initParallax(ctx) {
    $all('[data-rv-parallax]', ctx).forEach(function (el) {
      if (parallax.indexOf(el) === -1) parallax.push(el);
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallax.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-rv-parallax')) || 0.12;
        var centro = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (centro * -k).toFixed(1) + 'px,0)';
      });
      manifiesto();
      ticking = false;
    });
  }

  /* ---------- Manifiesto: palabras que se encienden con el scroll ---------- */
  var manis = [];
  function initManifiesto(ctx) {
    $all('[data-rv-palabras]:not([data-rv-hecho])', ctx).forEach(function (el) {
      el.setAttribute('data-rv-hecho', '');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodos = []; while (walker.nextNode()) nodos.push(walker.currentNode);
      nodos.forEach(function (n) {
        var frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
          var s = document.createElement('span'); s.className = 'rv-palabra'; s.textContent = p; frag.appendChild(s);
        });
        n.parentNode.replaceChild(frag, n);
      });
      manis.push({ el: el, palabras: $all('.rv-palabra', el) });
    });
  }
  function manifiesto() {
    var vh = window.innerHeight;
    manis.forEach(function (m) {
      var r = m.el.getBoundingClientRect();
      var prog = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      prog = Math.max(0, Math.min(1, prog));
      var n = Math.round(prog * m.palabras.length);
      m.palabras.forEach(function (p, i) { p.classList.toggle('is-on', i < n); });
    });
  }

  /* ---------- Pestañas de destacados ---------- */
  function initTabs(ctx) {
    $all('[data-rv-tabs]', ctx).forEach(function (wrap) {
      var tabs = $all('[role="tab"]', wrap);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          $all('[role="tabpanel"]', wrap).forEach(function (p) {
            var on = p.id === tab.getAttribute('aria-controls');
            p.hidden = !on;
            if (on) { p.classList.remove('is-anim'); void p.offsetWidth; p.classList.add('is-anim'); }
          });
        });
      });
    });
  }

  /* ---------- Escena fija de tecnología ---------- */
  function initTec(ctx) {
    $all('[data-rv-tec]', ctx).forEach(function (wrap) {
      var items = $all('.rv-tec__item', wrap);
      var imgs = $all('.rv-tec__visual img', wrap);
      var barras = $all('.rv-tec__progreso span', wrap);
      if (!items.length || !('IntersectionObserver' in window)) return;
      function activar(i) {
        items.forEach(function (it, k) { it.classList.toggle('is-activa', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-activa', k === i); });
        barras.forEach(function (b, k) { b.classList.toggle('is-hecha', k <= i); });
      }
      activar(0);
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) activar(items.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (it) { obs.observe(it); });
    });
  }

  /* ---------- Acordeones con altura animada ---------- */
  function initAcordeon(ctx) {
    $all('details.rv-faq__item:not([data-rv-hecho])', ctx).forEach(function (d) {
      d.setAttribute('data-rv-hecho', '');
      if (d.open) d.classList.add('is-abierto');
      var sum = d.querySelector('summary');
      sum.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.open) {
          d.classList.remove('is-abierto');
          setTimeout(function () { d.open = false; }, reduce ? 0 : 450);
        } else {
          d.open = true;
          requestAnimationFrame(function () { d.classList.add('is-abierto'); });
        }
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(ctx) {
    $all('[data-rv-producto]:not([data-rv-hecho])', ctx).forEach(function (root) {
      root.setAttribute('data-rv-hecho', '');
      var datos = root.querySelector('[data-rv-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var form = root.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = root.querySelector('[data-rv-comprar]');
      var precio = root.querySelector('[data-rv-precio]');
      var antes = root.querySelector('[data-rv-antes]');
      var principal = root.querySelector('.rv-prod__principal');
      var fotos = principal ? $all('img', principal) : [];
      var minis = $all('.rv-prod__mini', root);
      var actual = 0;
      var formato = root.getAttribute('data-rv-moneda') || '${{amount}}';

      function dinero(c) {
        var n = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formato.replace(/\{\{\s*amount[^}]*\}\}/, n);
      }
      function verFoto(i) {
        if (!fotos.length) return;
        actual = (i + fotos.length) % fotos.length;
        fotos.forEach(function (f, k) { f.classList.toggle('is-activa', k === actual); });
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === actual); });
        principal.classList.remove('is-zoom');
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { verFoto(k); }); });
      $all('[data-rv-foto]', root).forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); verFoto(actual + (+b.getAttribute('data-rv-foto'))); });
      });
      if (principal) {
        principal.addEventListener('click', function (e) {
          var img = fotos[actual]; if (!img) return;
          var r = principal.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          principal.classList.toggle('is-zoom');
        });
        var x0 = null;
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) verFoto(actual + (dx < 0 ? 1 : -1));
        });
      }

      function seleccion() {
        return $all('.rv-prod__opcion', root).map(function (fs) {
          var c = fs.querySelector('input:checked'); return c ? c.value : null;
        });
      }
      function actualizar() {
        var sel = seleccion();
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        $all('.rv-prod__opcion', root).forEach(function (fs, i) {
          var c = fs.querySelector('input:checked'); var et = fs.querySelector('legend span');
          if (c && et) et.textContent = c.value;
        });
        if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = boton.getAttribute('data-txt-no'); } return; }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (antes) { antes.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.getAttribute('data-txt-si') : boton.getAttribute('data-txt-agotado');
        }
        if (v.featured_media && fotos.length) {
          var idx = fotos.findIndex(function (f) { return f.getAttribute('data-media-id') == v.featured_media.id; });
          if (idx > -1) verFoto(idx);
        }
        if (history.replaceState && root.hasAttribute('data-rv-url')) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
      }
      $all('.rv-prod__opcion input', root).forEach(function (inp) { inp.addEventListener('change', actualizar); });

      if (form && window.fetch) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (boton) boton.classList.add('is-cargando');
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
          }).then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function () { return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-icon-bubble'); })
            .then(function (r) { return r.json(); })
            .then(function (s) {
              var burbuja = document.getElementById('cart-icon-bubble');
              if (burbuja && s['cart-icon-bubble']) {
                var tmp = document.createElement('div'); tmp.innerHTML = s['cart-icon-bubble'];
                var nuevo = tmp.querySelector('.shopify-section') || tmp; burbuja.innerHTML = nuevo.innerHTML;
              }
              toast(root.getAttribute('data-txt-anadido'), root.getAttribute('data-txt-ver'));
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (boton) boton.classList.remove('is-cargando'); });
        });
      }
    });
  }
  function toast(txt, ver) {
    var t = document.querySelector('.rv-toast');
    if (!t) {
      t = document.createElement('div'); t.className = 'rv-toast'; t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span>' + txt + '</span><a href="' + ((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart') + '">' + ver + '</a>';
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  /* ---------- Orden en colección ---------- */
  function initOrden(ctx) {
    $all('[data-rv-orden]', ctx).forEach(function (s) {
      s.addEventListener('change', function () {
        var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString();
      });
    });
  }

  /* ---------- Altura del header (para elementos fijos) ---------- */
  function medirHeader() {
    var h = document.querySelector('.section-header');
    if (h) docEl.style.setProperty('--rv-header', h.offsetHeight + 'px');
  }

  function init(ctx) {
    initSplit(ctx); initReveal(ctx); initParallax(ctx); initManifiesto(ctx);
    initTabs(ctx); initTec(ctx); initAcordeon(ctx); initProducto(ctx); initOrden(ctx);
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    medirHeader(); init(document);
    if (!reduce) window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { medirHeader(); onScroll(); });
  });
  /* Editor de Shopify: re-iniciar al añadir o cambiar secciones */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
